<!-- <p-table #pt [value]="users" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" [pageLinks]="3"
[lazy]="true" (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
[multiSortMeta]="multiSortMeta" dataKey="userId" [loading]="loading" [scrollable]="true" scrollHeight="500px"
[style]="{'width':'100%'}"> -->
<div class="container-fluid">
  <form [formGroup]="userAddForm">
    <mat-accordion>
      <mat-expansion-panel style="background-color: #f9f9f9;" [expanded]="false" hideToggle="true" #contacts>
        <mat-expansion-panel-header>
          <mat-panel-title>
            @if (!contacts?.expanded) {
              <mat-icon style="color:green; font-size:140%">add_circle</mat-icon>
            }
            @if (contacts?.expanded) {
              <mat-icon style="color:grey; font-size:140%">unfold_less</mat-icon>
            }
            &nbsp;User
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <mat-card>
          <mat-card-content class="row wrap">
            <mat-form-field class="col-lg-5">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.firstName; track validation) {
                <mat-error>
                  @if (userAddForm.get('firstName').hasError(validation.type) && (userAddForm.get('firstName').dirty || userAddForm.get('firstName').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-5">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.lastName; track validation) {
                <mat-error>
                  @if (userAddForm.get('lastName').hasError(validation.type) && (userAddForm.get('lastName').dirty || userAddForm.get('lastName').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>Position</mat-label>
              <input matInput formControlName="title" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.title; track validation) {
                <mat-error>
                  @if (userAddForm.get('title').hasError(validation.type) && (userAddForm.get('title').dirty || userAddForm.get('title').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-4">
              <mat-label>Email</mat-label> <input matInput formControlName="email" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.email; track validation) {
                <mat-error>
                  @if (userAddForm.get('email').hasError(validation.type) && (userAddForm.get('email').dirty || userAddForm.get('email').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>Phone</mat-label> <input matInput formControlName="phone" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.phone; track validation) {
                <mat-error>
                  @if (userAddForm.get('phone').hasError(validation.type) && (userAddForm.get('phone').dirty || userAddForm.get('phone').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-2">
              <mat-label>Phone Type</mat-label>
              <mat-select [(value)]="userAddForm.value.phoneType" formControlName="phoneType">
                @for ( stat of phoneTypes; track  stat) {
                  <mat-option [value]="stat.value"> {{stat.name}} </mat-option>
                }
              </mat-select>
              @for (validation of validationMessages.phoneType; track validation) {
                <mat-error>
                  @if (userAddForm.get('phoneType').hasError(validation.type) && (userAddForm.get('phoneType').dirty || userAddForm.get('phoneType').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-6">
              <mat-label>Company Name</mat-label> <input matInput formControlName="companyName" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.companyName; track validation) {
                <mat-error>
                  @if (userAddForm.get('companyName').hasError(validation.type) && (userAddForm.get('companyName').dirty || userAddForm.get('companyName').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="col-lg-6">
              <mat-label>Website</mat-label> <input matInput formControlName="website" readonly="{{formReadOnly}}">
              @for (validation of validationMessages.website; track validation) {
                <mat-error>
                  @if (userEditForm.get('website').hasError(validation.type) && (userEditForm.get('website').dirty || userEditForm.get('website').touched)) {
                    <mat-error class="error-message">
                    {{validation.message}}</mat-error>
                  }
                </mat-error>
              }
            </mat-form-field>
            <div class="flex-1" style="float: right">
              <button mat-raised-button color="primary" (click)="formAdd();" style="float: right;">Add</button>
              <button mat-button type="button" style="float: right;" (click)="contacts.expanded = false;">Cancel</button>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
</div>
